// src/components/questioncompletiondialog/index.tsx
import { Close } from "@mui/icons-material";
import { Dialog, DialogProps } from "@mui/material";

import ClappingHands from "../../assets/icons/clapping_hands.svg";
import ClockCountdown from "../../assets/icons/ClockCountdown.svg";
import Button from "../button/index";
import { QuestionCompletionDialogProps } from "./interface";
import {
  ButtonsContainer,
  ClappingIcons,
  CoinsContainer,
  CoinsText,
  DialogCloseButton,
  DialogContentWrapper,
  HeadingText,
  HighlightedCoins,
  ImageContainer,
  SubheadingText,
} from "./style.components";

const QuestionCompletionDialog = (props: QuestionCompletionDialogProps) => {
  const {
    show,
    dismiss,
    heading,
    subheading,
    imageSrc,
    earnedCoins,
    onChangeCategoryClick,
    onNextQuestionClick,
    changeCategoryText,
    nextQuestionText,
    isImageDisabled,
    isClappingHandDisabled,
    isCoinsTextDisabled,
    isChangeCategoryButtonDisabled = false,
    isNextButtonDisabled = false,
  } = props;

  const handleClose: DialogProps["onClose"] = (event: any, reason: any) => {
    if (reason && reason === "backdropClick") return;
    dismiss();
  };

  return (
    <Dialog open={show} onClose={handleClose}>
      <DialogContentWrapper>
        <DialogCloseButton onClick={dismiss}>
          <Close />
        </DialogCloseButton>

        <HeadingText>
          {heading}
          <ClappingIcons
            src={isClappingHandDisabled ? ClockCountdown : ClappingHands}
            alt={isClappingHandDisabled ? "Clock Countdown" : "Clapping Hands"}
          />
        </HeadingText>
        <SubheadingText>{subheading}</SubheadingText>

        {isImageDisabled && (
          <ImageContainer>
            <img src={imageSrc} alt="Completion" />
          </ImageContainer>
        )}

        {isCoinsTextDisabled && (
          <CoinsContainer>
            <CoinsText>
              You’ve earned{" "}
              <HighlightedCoins>{earnedCoins} Points</HighlightedCoins>
            </CoinsText>
          </CoinsContainer>
        )}

        <ButtonsContainer>
          {!isChangeCategoryButtonDisabled && (
            <Button
              type="button"
              variant="outlined"
              margintop="0px"
              bordercolor="black"
              buttonsize={1}
              onClickHandler={onChangeCategoryClick}
            >
              {changeCategoryText}
            </Button>
          )}
          {!isNextButtonDisabled && (
            <Button
              type="button"
              variant="contained"
              margintop="0px"
              bgcolor="#000000"
              textcolor="white"
              buttonsize={1}
              onClickHandler={onNextQuestionClick}
            >
              {nextQuestionText}
            </Button>
          )}
        </ButtonsContainer>
      </DialogContentWrapper>
    </Dialog>
  );
};

export default QuestionCompletionDialog;
